import { render, staticRenderFns } from "./ContentWrapper.vue?vue&type=template&id=65f715d5"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../../dev/hemotrack-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports